export const sharedConnectionInputFields = `
    $useCacheCount: Boolean,
`;

export const sharedConnectionInput = `
    useCacheCount: $useCacheCount,
`;
